import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LicitacoesComponent } from './components/licitacoes/licitacoes.component';
import { LicitacaoListSimpleComponent } from './components/licitacao-list-simple/licitacao-list-simple.component';
import { LicitacaoEditComponent } from './components/licitacao-edit/licitacao-edit.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    children: [
      { path: 'licitacao', component: LicitacoesComponent },
      { path: 'licitacao/list', component: LicitacaoListSimpleComponent },
      { path: 'licitacao/edit/:id', component: LicitacaoEditComponent }
    ]
  },
  { path: 'licitacoes', component: LicitacaoListSimpleComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts